import api from "./api";

const getPorts = async () => {

    const response = await api.get("/api/ports");

    return response.data.data;

};

const addPort = async(formData)=>{
    const response = await api.post(
        "/api/port",
        formData
    );

    return response.data;

}

const updatePort = async(id,formData)=>{

    const response = await api.put(
        `/api/ports/${id}`,
        formData
    );

    return response.data;

}

const deletePort = async(id)=>{

    const response = await api.delete(`/api/ports/${id}`);

    return response.data;

}

export default{
    getPorts,
    addPort,
    updatePort,
    deletePort
}